"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialVentilatedWallConfigurationState = void 0;
exports.initialVentilatedWallConfigurationState = {
    humanReadableName: null,
    wallType: {
        type: null,
        material: null,
    },
    facadeCladding: {
        type: null,
        material: null,
    },
    wallInsulation: {
        type: null,
        material: null,
    },
    files: {
        nl_be: null,
        fr_be: null,
        nl_nl: null,
        fr_fr: null,
        de_de: null,
        en_en: null,
    },
};
